import { Directive, ElementRef, Renderer2, Input, OnInit } from '@angular/core';

 
@Directive({ selector: '[width]' })
export class WidthDirective implements OnInit {

    @Input('width') width?: number | string;


    constructor(private el: ElementRef, private r: Renderer2) {


    }

    ngOnInit(): void {
        let dom = this.el.nativeElement;

        const width: string = typeof this.width == 'number'  ? isNaN(this.width) ? `${this.width}` : `${this.width}px`
                                                             : `${this.width}`;

        this.r.setStyle(dom, "width", width);
    }

    ngOnChanges(): void {
        let dom = this.el.nativeElement;

        const width: string = typeof this.width == 'number' ? isNaN(this.width) ? `${this.width}` : `${this.width}px`
                                                            : `${this.width}`;

        this.r.setStyle(dom, "width", width);
    }
}
